module.exports = __webpack_public_path__ + "img/arrow-left-white.50c46ca1.svg";